/**
 * ============================================================
 * Whatdaphin.com × PostHog — A/B Experiments
 * ============================================================
 * Installation: Add to Shopify Admin > Online Store > Themes
 *   > Edit Code > Assets > posthog-experiments.js (new file)
 * Include AFTER posthog-tracking.js in theme.liquid:
 *   {{ 'posthog-experiments.js' | asset_url | script_tag }}
 *
 * BEFORE RUNNING EACH TEST: Create the Feature Flag in
 * PostHog > Feature Flags > New Feature Flag
 * (exact key names are documented per experiment below)
 * ============================================================
 */

(function () {
  'use strict';

  // Wait for PostHog to be ready and feature flags to load
  if (typeof posthog === 'undefined') {
    console.warn('[PostHog Experiments] PostHog not found. Load posthog-tracking.js first.');
    return;
  }

  posthog.onFeatureFlags(function () {
    initAllExperiments();
  });

  function initAllExperiments() {
    experiment1_GrindTooltip();
    experiment2_FreshnessBadge();
    experiment3_SubscriptionDefault();
    experiment4_CollectionReviews();
    experiment5_FreeShippingProgress();
  }


  // ═══════════════════════════════════════════════════════════
  // EXPERIMENT 1: Grind Selector with Helper Tooltip
  // ═══════════════════════════════════════════════════════════
  // PostHog Feature Flag Key: exp-grind-tooltip
  // Variants: control | tooltip
  // Pages: /products/*
  // Primary metric: add_to_cart (from product_viewed)
  // Run for: 4–6 weeks
  // ═══════════════════════════════════════════════════════════
  function experiment1_GrindTooltip() {
    if (window.location.pathname.indexOf('/products/') === -1) return;

    var variant = posthog.getFeatureFlag('exp-grind-tooltip');
    if (!variant || variant === 'control') return;

    // Find the grind selector — try multiple theme patterns
    var grindWrapper = findGrindSelectorWrapper();
    if (!grindWrapper) return;

    // Inject the tooltip trigger link
    var tooltipTrigger = document.createElement('button');
    tooltipTrigger.type        = 'button';
    tooltipTrigger.className   = 'wdp-grind-help-btn';
    tooltipTrigger.textContent = 'Not sure which grind? 👋';
    tooltipTrigger.setAttribute('aria-expanded', 'false');
    tooltipTrigger.setAttribute('aria-controls', 'wdp-grind-tooltip');

    var tooltipEl = document.createElement('div');
    tooltipEl.id        = 'wdp-grind-tooltip';
    tooltipEl.className = 'wdp-tooltip';
    tooltipEl.setAttribute('role', 'tooltip');
    tooltipEl.setAttribute('aria-hidden', 'true');
    tooltipEl.innerHTML = [
      '<ul class="wdp-tooltip__list">',
      '  <li><strong>Whole Bean</strong> — You have a grinder at home ✓</li>',
      '  <li><strong>Filter / Drip</strong> — V60, Chemex, Hario, drip machine</li>',
      '  <li><strong>Espresso</strong> — Espresso machine or Moka pot</li>',
      '  <li><strong>French Press</strong> — French press, AeroPress (coarse)</li>',
      '  <li><strong>Cold Brew</strong> — Cold brew kit (extra coarse)</li>',
      '</ul>',
      '<p class="wdp-tooltip__footer">Still unsure? <a href="/pages/brew-guide">Read our brew guide →</a></p>',
      '<button type="button" class="wdp-tooltip__close" aria-label="Close">✕</button>'
    ].join('');

    // Inject styles
    injectStyles('wdp-exp1-styles', [
      '.wdp-grind-help-btn {',
      '  background: none; border: none; padding: 4px 0; margin-top: 6px;',
      '  color: #6B4F2A; font-size: 0.85em; cursor: pointer;',
      '  text-decoration: underline; text-underline-offset: 2px;',
      '  display: block;',
      '}',
      '.wdp-grind-help-btn:hover { color: #3D2B0F; }',
      '.wdp-tooltip {',
      '  display: none; background: #FFF8F2; border: 1px solid #D4A96A;',
      '  border-radius: 8px; padding: 16px 18px; margin-top: 10px;',
      '  box-shadow: 0 4px 16px rgba(0,0,0,0.12);',
      '  max-width: 360px; position: relative;',
      '}',
      '.wdp-tooltip.is-open { display: block; }',
      '.wdp-tooltip__list { margin: 0; padding: 0 0 0 16px; }',
      '.wdp-tooltip__list li { margin-bottom: 6px; font-size: 0.9em; line-height: 1.5; }',
      '.wdp-tooltip__footer { margin: 10px 0 0; font-size: 0.82em; color: #666; }',
      '.wdp-tooltip__close {',
      '  position: absolute; top: 8px; right: 10px;',
      '  background: none; border: none; cursor: pointer;',
      '  font-size: 0.9em; color: #999; padding: 2px 4px;',
      '}',
    ].join('\n'));

    grindWrapper.appendChild(tooltipTrigger);
    grindWrapper.appendChild(tooltipEl);

    var tooltipOpen = false;

    tooltipTrigger.addEventListener('click', function () {
      tooltipOpen = !tooltipOpen;
      tooltipEl.classList.toggle('is-open', tooltipOpen);
      tooltipEl.setAttribute('aria-hidden', String(!tooltipOpen));
      tooltipTrigger.setAttribute('aria-expanded', String(tooltipOpen));

      if (tooltipOpen) {
        posthog.capture('experiment_interaction', {
          experiment:      'exp-grind-tooltip',
          variant:         'tooltip',
          action:          'tooltip_opened',
          product_name:    document.title.replace(/ [–—-].*$/, '').trim(),
          time_on_page:    Math.round((Date.now() - window._phPageLoadTime) / 1000),
        });
      }
    });

    tooltipEl.querySelector('.wdp-tooltip__close').addEventListener('click', function () {
      tooltipOpen = false;
      tooltipEl.classList.remove('is-open');
      tooltipEl.setAttribute('aria-hidden', 'true');
      tooltipTrigger.setAttribute('aria-expanded', 'false');
    });

    // Track exposure
    posthog.capture('experiment_exposure', {
      experiment: 'exp-grind-tooltip',
      variant:    'tooltip',
    });
  }

  function findGrindSelectorWrapper() {
    // Try to find the wrapper around the grind variant selector
    var labels = document.querySelectorAll('.selector-wrapper label, .product-form__label, .variant-title');
    for (var i = 0; i < labels.length; i++) {
      var text = (labels[i].textContent || '').toLowerCase();
      if (/grind|grindsize|grind size|grind type/i.test(text)) {
        return labels[i].closest('.selector-wrapper, .product-form__input, .form__row') || labels[i].parentNode;
      }
    }
    return null;
  }


  // ═══════════════════════════════════════════════════════════
  // EXPERIMENT 2: Roast Date Freshness Badge
  // ═══════════════════════════════════════════════════════════
  // PostHog Feature Flag Key: exp-freshness-badge
  // Variants: control | badge
  // Pages: /products/* AND /collections/*
  // Primary metric: add_to_cart rate
  // ═══════════════════════════════════════════════════════════
  function experiment2_FreshnessBadge() {
    var variant = posthog.getFeatureFlag('exp-freshness-badge');
    if (!variant || variant === 'control') return;

    var isProduct    = window.location.pathname.indexOf('/products/') > -1;
    var isCollection = window.location.pathname.indexOf('/collections/') > -1;

    if (!isProduct && !isCollection) return;

    injectStyles('wdp-exp2-styles', [
      '.wdp-freshness-badge {',
      '  display: inline-flex; align-items: center; gap: 6px;',
      '  background: #F0FAF0; border: 1px solid #4CAF50;',
      '  color: #2E7D32; border-radius: 20px;',
      '  padding: 5px 12px; font-size: 0.82em; font-weight: 600;',
      '  margin-bottom: 12px; white-space: nowrap;',
      '}',
      '.wdp-freshness-badge::before {',
      '  content: ""; display: inline-block;',
      '  width: 8px; height: 8px; border-radius: 50%;',
      '  background: #4CAF50; animation: wdp-pulse 2s infinite;',
      '}',
      '@keyframes wdp-pulse {',
      '  0%,100% { opacity: 1; } 50% { opacity: 0.4; }',
      '}',
      '.wdp-freshness-badge--card {',
      '  font-size: 0.75em; padding: 3px 8px; margin-top: 4px;',
      '  border-radius: 12px;',
      '}',
    ].join('\n'));

    var badge = document.createElement('div');
    badge.className   = 'wdp-freshness-badge';
    badge.textContent = 'Roasted to order — ships within 48 hours';

    if (isProduct) {
      // Insert badge above the ATC button on product pages
      var atcBtn = document.querySelector(
        '[name="add"], .product-form__submit, .btn--add-to-cart, .product__submit'
      );
      if (atcBtn) {
        var atcWrapper = atcBtn.closest('form, .product-form__buttons') || atcBtn.parentNode;
        atcWrapper.insertBefore(badge, atcWrapper.firstChild);
      }
    }

    if (isCollection) {
      // Add smaller badge to each product card
      document.querySelectorAll('.product-card, .grid-product, [data-product-card]').forEach(function(card) {
        var smallBadge       = badge.cloneNode(true);
        smallBadge.className = 'wdp-freshness-badge wdp-freshness-badge--card';
        var titleEl = card.querySelector('.product-card__title, .grid-product__title, h3');
        if (titleEl) titleEl.insertAdjacentElement('afterend', smallBadge);
      });
    }

    posthog.capture('experiment_exposure', {
      experiment: 'exp-freshness-badge',
      variant:    'badge',
      page_type:  isProduct ? 'product' : 'collection',
    });
  }


  // ═══════════════════════════════════════════════════════════
  // EXPERIMENT 3: Subscription as Default Selection
  // ═══════════════════════════════════════════════════════════
  // PostHog Feature Flag Key: exp-subscription-default
  // Variants: control | subscription_first
  // Pages: /products/*
  // Primary metric: is_subscription:true on order_completed
  // NOTE: Works with Recharge, Bold Subscriptions, and
  //       Shopify native selling plans
  // ═══════════════════════════════════════════════════════════
  function experiment3_SubscriptionDefault() {
    if (window.location.pathname.indexOf('/products/') === -1) return;

    var variant = posthog.getFeatureFlag('exp-subscription-default');
    if (!variant || variant === 'control') return;

    // Attempt to pre-select the subscription option
    // Pattern 1: Recharge widget
    var rechargeSubscribeBtn = document.querySelector(
      '.rc_widget__option[data-value="subscription"], ' +
      '[data-purchase-type="subscription"]'
    );
    if (rechargeSubscribeBtn && !rechargeSubscribeBtn.classList.contains('active')) {
      rechargeSubscribeBtn.click();
    }

    // Pattern 2: Native Shopify selling plans
    var sellingPlanRadios = document.querySelectorAll('input[name="selling_plan"]');
    if (sellingPlanRadios.length > 0) {
      // Find the first non-empty selling plan (i.e., the subscription one)
      sellingPlanRadios.forEach(function(radio) {
        if (radio.value && radio.value !== '') {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    // Inject social proof line near subscription selector
    var subSelector = document.querySelector(
      '.rc_widget, .selling-plan-selector, [data-selling-plan-selector]'
    );
    if (subSelector) {
      injectStyles('wdp-exp3-styles', [
        '.wdp-sub-proof {',
        '  font-size: 0.82em; color: #5C7A3E;',
        '  margin-top: 6px; display: flex; align-items: center; gap: 5px;',
        '}',
        '.wdp-sub-proof::before { content: "☕"; }',
      ].join('\n'));

      var proof = document.createElement('p');
      proof.className   = 'wdp-sub-proof';
      proof.textContent = 'Join 1,200+ subscribers — pause or cancel anytime';
      subSelector.insertAdjacentElement('afterend', proof);
    }

    posthog.capture('experiment_exposure', {
      experiment: 'exp-subscription-default',
      variant:    'subscription_first',
    });
  }


  // ═══════════════════════════════════════════════════════════
  // EXPERIMENT 4: Star Ratings on Collection Cards
  // ═══════════════════════════════════════════════════════════
  // PostHog Feature Flag Key: exp-collection-reviews
  // Variants: control | show_ratings
  // Pages: /collections/*
  // Primary metric: collection → product_viewed → add_to_cart rate
  // REQUIRES: Your review app to have product metafields OR
  //           a products.json endpoint with review data
  // ═══════════════════════════════════════════════════════════
  function experiment4_CollectionReviews() {
    if (window.location.pathname.indexOf('/collections/') === -1) return;

    var variant = posthog.getFeatureFlag('exp-collection-reviews');
    if (!variant || variant === 'control') return;

    injectStyles('wdp-exp4-styles', [
      '.wdp-card-rating {',
      '  display: flex; align-items: center; gap: 4px;',
      '  font-size: 0.78em; color: #555; margin-top: 4px;',
      '}',
      '.wdp-card-stars { color: #F4A421; letter-spacing: -1px; }',
      '.wdp-card-count { color: #888; }',
    ].join('\n'));

    // Shopify exposes product data via product card [data-product-id]
    // We can fetch review data from the Shopify Judge.me or SPR metafields
    document.querySelectorAll('[data-product-id], .grid-product, .product-card').forEach(function(card) {
      var productHandle = (card.querySelector('a[href*="/products/"]') || {}).href;
      if (!productHandle) return;

      var handle = productHandle.split('/products/')[1];
      if (!handle) return;
      handle = handle.split('?')[0].split('#')[0];

      // Fetch product JSON to get review metafields (if available)
      fetch('/products/' + handle + '.json')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var product = data.product;
          // Judge.me / SPR expose ratings in metafields or via their own endpoints
          // This checks common metafield keys
          var ratingMeta  = getMetafieldValue(product, 'reviews', 'rating');
          var countMeta   = getMetafieldValue(product, 'reviews', 'rating_count');

          if (ratingMeta && countMeta) {
            var rating   = parseFloat(ratingMeta);
            var count    = parseInt(countMeta);
            var stars    = generateStars(rating);
            var ratingEl = document.createElement('div');
            ratingEl.className = 'wdp-card-rating';
            ratingEl.innerHTML = [
              '<span class="wdp-card-stars">' + stars + '</span>',
              '<span class="wdp-card-count">(' + count + ')</span>',
            ].join('');

            var titleEl = card.querySelector('.product-card__title, .grid-product__title, h3, .product-item__title');
            if (titleEl) titleEl.insertAdjacentElement('afterend', ratingEl);
          }
        })
        .catch(function(){});
    });

    posthog.capture('experiment_exposure', {
      experiment: 'exp-collection-reviews',
      variant:    'show_ratings',
    });
  }

  function getMetafieldValue(product, namespace, key) {
    if (!product || !product.metafields) return null;
    var mf = product.metafields.find(function(m) {
      return m.namespace === namespace && m.key === key;
    });
    return mf ? mf.value : null;
  }

  function generateStars(rating) {
    var full  = Math.floor(rating);
    var half  = (rating - full) >= 0.5 ? 1 : 0;
    var empty = 5 - full - half;
    return '★'.repeat(full) + (half ? '½' : '') + '☆'.repeat(empty);
  }


  // ═══════════════════════════════════════════════════════════
  // EXPERIMENT 5: Free Shipping Progress Bar in Cart
  // ═══════════════════════════════════════════════════════════
  // PostHog Feature Flag Key: exp-shipping-progress
  // Variants: control | progress_bar
  // Pages: /cart AND cart drawer (any page with cart drawer)
  // Primary metric: AOV, checkout_started rate from cart_viewed
  // ═══════════════════════════════════════════════════════════
  var FREE_SHIPPING_THRESHOLD = 99; // ← Set your actual free shipping threshold in USD

  function experiment5_FreeShippingProgress() {
    var variant = posthog.getFeatureFlag('exp-shipping-progress');
    if (!variant || variant === 'progress_bar') {
      // We want to run this on control too but only render for variant
      if (variant !== 'progress_bar') return;
    }

    injectStyles('wdp-exp5-styles', [
      '.wdp-shipping-bar {',
      '  padding: 12px 16px;',
      '  background: #FFFDF7;',
      '  border-bottom: 1px solid #EEE;',
      '  font-size: 0.87em;',
      '}',
      '.wdp-shipping-bar__text {',
      '  margin: 0 0 8px;',
      '  color: #333;',
      '  font-weight: 500;',
      '}',
      '.wdp-shipping-bar__text strong { color: #2E7D32; }',
      '.wdp-shipping-bar__text--done { color: #2E7D32; }',
      '.wdp-shipping-bar__track {',
      '  height: 6px;',
      '  background: #E0E0E0;',
      '  border-radius: 3px;',
      '  overflow: hidden;',
      '}',
      '.wdp-shipping-bar__fill {',
      '  height: 100%;',
      '  background: linear-gradient(90deg, #6B4F2A, #D4A96A);',
      '  border-radius: 3px;',
      '  transition: width 0.4s ease;',
      '}',
    ].join('\n'));

    function renderShippingBar(cartTotal) {
      var remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - cartTotal);
      var progress  = Math.min(100, Math.round((cartTotal / FREE_SHIPPING_THRESHOLD) * 100));

      var barHtml = [
        '<div class="wdp-shipping-bar" id="wdp-shipping-bar">',
        '  <p class="wdp-shipping-bar__text ' + (remaining === 0 ? 'wdp-shipping-bar__text--done' : '') + '">',
        remaining === 0
          ? '🚚 <strong>You\'ve unlocked free shipping!</strong>'
          : '🚚 Add <strong>$' + remaining.toFixed(2) + '</strong> more for free shipping',
        '  </p>',
        '  <div class="wdp-shipping-bar__track">',
        '    <div class="wdp-shipping-bar__fill" style="width:' + progress + '%"></div>',
        '  </div>',
        '</div>'
      ].join('');

      return barHtml;
    }

    function injectShippingBar() {
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        var total   = cart.total_price / 100;
        var barHtml = renderShippingBar(total);

        // On cart page — inject at top of cart form
        var cartForm = document.querySelector('form[action="/cart"], .cart__form, #cart-form');
        if (cartForm && !document.getElementById('wdp-shipping-bar')) {
          cartForm.insertAdjacentHTML('afterbegin', barHtml);
        }

        // In cart drawer — inject at top of drawer content
        var drawer = document.querySelector(
          '.cart-drawer__content, .drawer__inner, [data-cart-drawer], #CartDrawer'
        );
        if (drawer && !document.getElementById('wdp-shipping-bar')) {
          drawer.insertAdjacentHTML('afterbegin', barHtml);
        }

        // Track exposure
        posthog.capture('experiment_exposure', {
          experiment:          'exp-shipping-progress',
          variant:             'progress_bar',
          cart_value:          total,
          threshold:           FREE_SHIPPING_THRESHOLD,
          gap_to_free_shipping: Math.max(0, FREE_SHIPPING_THRESHOLD - total),
        });

      }).catch(function(){});
    }

    // Run on cart page
    if (window.location.pathname === '/cart') {
      injectShippingBar();
    }

    // Re-run when cart drawer opens (observe DOM changes)
    var drawerObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            var isDrawer = node.classList &&
              (node.classList.contains('cart-drawer') ||
               node.classList.contains('drawer') ||
               node.id === 'CartDrawer');
            if (isDrawer) {
              setTimeout(injectShippingBar, 100); // small delay for content to render
            }
          }
        });
      });
    });
    drawerObserver.observe(document.body, { childList: true, subtree: true });

    // Also re-inject when cart is updated (AJAX cart updates)
    document.addEventListener('cart:updated', injectShippingBar);
    document.addEventListener('cart:refresh', injectShippingBar);
  }


  // ═══════════════════════════════════════════════════════════
  // SHARED UTILITY
  // ═══════════════════════════════════════════════════════════
  function injectStyles(id, css) {
    if (document.getElementById(id)) return;
    var style = document.createElement('style');
    style.id        = id;
    style.textContent = css;
    document.head.appendChild(style);
  }

  console.log('[PostHog Experiments] Whatdaphin experiments loaded ✓');

})();
